<template>
  <ModalDefault
    :id="id"
    size="md"
    :title="titleComponent"
    :button="false"
    :show-close="showClose"
    :fnc-on-close="handleCloseModal"
  >
    <template #modal-body>
      <div class="grid grid-cols-2 gap-4">
        <slot name="before-reason" />
        <div v-if="warningMessage" class="col-span-2">
          <AlertDefault
            color="yellow"
            titulo="Advertencia"
            :texto="warningMessage"
            icono="ExclamationTriangleIcon"
          />
        </div>
        <div class="col-span-2">
          <TextareaDefault
            id="descripcion-motivo"
            v-model="form.cmotMotivo"
            :error="v$.form.cmotMotivo"
            placeholder="Ingrese el motivo"
            :maxlength="2000"
            :show-character-count="true"
            rows="3"
            class="w-full"
          />
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="flex justify-between gap-2">
        <ButtonDefault v-if="showClose" @click="handleCloseModal">
          Cerrar
        </ButtonDefault>
        <span v-else></span>
        <ButtonDefault
          color="blue"
          @click="createRecord"
        >
          Guardar
        </ButtonDefault>
      </div>
    </template>
  </ModalDefault>
</template>

<script lang="ts" setup>
import { ref, toRefs } from 'vue'
import { closeModal } from '@/modules/Core/usings/generales'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import AlertDefault from '@/modules/Core/components/general/AlertDefault.vue'

const props = withDefaults(defineProps<{
  titleComponent: string
  confirmationMessage?: string
  confirmationTitle?: string
  popup?: boolean
  id?: string
  warningMessage?: string
  showClose?: boolean
  callbackFnc: (motivo: string) => boolean | void | Promise<boolean | void>
}>(), {
  confirmationTitle: '¿Estas seguro de realizar esta acción?',
  confirmationMessage: 'Esta acción no se puede deshacer',
  popup: false,
  id: 'form-clear-hc',
  warningMessage: '',
  showClose: true
});
const { callbackFnc, confirmationTitle, confirmationMessage, popup, id, warningMessage, showClose } = toRefs(props);



const form = ref<{cmotMotivo: string}>({
  cmotMotivo: ''
})
const rules_form = {
  form: {
    cmotMotivo: { required },
  }
}
const v$ = useVuelidate(rules_form, { form }, { $lazy: true })

const handleCloseModal = () => {
  form.value.cmotMotivo = ''
  closeModal(id.value)
}

const createRecord = async () => {
  try {
    const isValid = await v$.value.$validate()

    if (!isValid) {
      window.notificacion.loading().remove()
      window.notificacion.notificacion(
        'failure',
        'Hay campos obligatorios sin diligenciar'
      )
      return
    }
    const _okCB = async () => {
      const resultado = await callbackFnc.value(form.value.cmotMotivo)
      if (resultado !== false) handleCloseModal()
    }
    if (popup.value === true) {
      await _okCB()
    }else{
      window.notificacion.confirmacion(confirmationTitle.value, confirmationMessage.value, () => _okCB(), () => { })
    }
  } catch (error) {
    window.notificacion.loading().remove()
    console.log(error)
  }
}

</script>
